var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-button',{attrs:{"big":"","fill":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }